import { createContext, type ReactNode } from "react"

export const NotebookCanvasContext = createContext<{
  assets: Record<string, string>
  renderEvidence: (index: number) => ReactNode
}>({ assets: {}, renderEvidence: () => null })
